import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-348.44 -348.44 2488.89 2488.89",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		transform: "matrix(1 0 0 -1 0 1536)",
		d: "M1643 902 919 178 783 42Q755 14 715.0 14.0Q675 14 647 42L511 178L149 540Q121 568 121.0 608.0Q121 648 149 676L285 812Q313 840 353.0 840.0Q393 840 421 812L715 517L1371 1174Q1399 1202 1439.0 1202.0Q1479 1202 1507 1174L1643 1038Q1671 1010 1671.0 970.0Q1671 930 1643 902Z"
	})
});
export default SvgCheck;
